// extracted by mini-css-extract-plugin
export default {"HowItWorks":"HowItWorks_HowItWorks__6Wf0D"};